import { faEnvelope, faMobileScreen, faUser } from '@fortawesome/free-solid-svg-icons';
import React, {useState } from 'react';
import {useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from 'react-redux';
import { msgAccessPromt } from "../../constant/constant";
import { isUserExists } from "../../features/userSlice";
import NavImage from "../../resources/NavImage";
import LanguageSwitcher from "../../resources/LanguageSwitcher";
import { useT } from "../../i18n";

const generateToken = () => `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

const SignupPage = () => {

  const [name, setname] = useState(localStorage.getItem('user_name') || '');
  // Prefilled when the login screen sent an unregistered number here
  const [phone, setPhone] = useState(localStorage.getItem('phone_number') || '');
  const [email, setEmail] = useState(localStorage.getItem('user_email') || '');
  const dispatch=useDispatch();
  const navigate = useNavigate();
  const { t } = useT();

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) {
      setPhone(value);
    }
  };

  const handleSubmit = async (e) =>  {
    e.preventDefault();
    if(!name.trim()){
        msgAccessPromt({dispatch,error:true,msg:'Enter User name !!'});
        return false;
    }
    if(!/^\d{10}$/.test(phone)){
        msgAccessPromt({dispatch,error:true,msg:'Enter Valid mobile number !!'});
        return false;
    }
    if(email && !/^\S+@\S+\.\S+$/.test(email)){
        msgAccessPromt({dispatch,error:true,msg:'Enter Valid email address !!'});
        return false;
    }

    msgAccessPromt({dispatch,msg:'LOADING',error:true});
    const token = localStorage.getItem('user_token') || generateToken();
    const dataSet = new FormData();
    dataSet.append('phone_number', phone);
    dataSet.append('token_id', token);

    try {
        const data = await dispatch(isUserExists(dataSet)).unwrap();
        if (data.success) {
            // Already registered: send them back to log in with their MPIN
            localStorage.setItem('phone_number', phone);
            msgAccessPromt({dispatch,error:false,msg:'This number is already registered. Please login.'});
            navigate("/login");
            return;
        }
    } catch (error) {
        console.error('API Error:', error);
        msgAccessPromt({dispatch,error:true,msg:error || 'Unable to continue. Please try again.'});
        return;
    }

    msgAccessPromt({dispatch,msg:'LOADING',error:false});
    localStorage.setItem('phone_number',phone);
    localStorage.setItem('user_token',token);
    localStorage.setItem('user_email',email.trim());
    localStorage.setItem('user_name',name.trim());
    navigate("/M_pin");
  };


      return (
        <div className='bodyDiv auth-page signup-page'>
           <LanguageSwitcher className="auth-lang" />
           <div className="auth-logo">
            <NavImage />
            <p className="brand-tagline">{t("Every Win, Securely Paid.")}</p>
            </div>
        <form className="signup-container" onSubmit={handleSubmit}>
    <div className="title_Form signup-heading" style={{justifyContent:'space-between'}}>
                <div className="title_left">
                    <h1 className="main_title">{t("Create Account")}</h1>
                    <p>{t('Create your new account')}</p>
                    </div>
                <div className="signup-icon-badge" aria-hidden="true">
                    <FontAwesomeIcon icon={faUser} />

                </div>
            </div>
            <div className="input-group signup-input-group">
                <span className="signup-field-icon" aria-hidden="true"><FontAwesomeIcon icon={faUser} /></span>
                <input className='input_lable_deep' type="text" autoComplete="name" value={name} onChange={(e)=>setname(e.target.value)} placeholder={t("Full name")} aria-label={t("Full name")} />
            </div>
            <div className="input-group signup-input-group">
                <span className="signup-field-icon" aria-hidden="true"><FontAwesomeIcon icon={faMobileScreen} /></span>
                <input className='input_lable_deep' type="tel" inputMode="numeric" autoComplete="tel" value={phone} onChange={handlePhoneChange} placeholder={t("Mobile number")} aria-label={t("Mobile number")} />
            </div>
            <div className="input-group signup-input-group">
                <span className="signup-field-icon" aria-hidden="true"><FontAwesomeIcon icon={faEnvelope} /></span>
                <input className='input_lable_deep' type="email" autoComplete="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder={t("Email address (optional)")} aria-label={t("Email address (optional)")} />
            </div>
            <button type="submit" className="continue-button">{t("Continue")}</button>
            <p className="signin-link signup-footer">{t("Already have an account?")} <a href="/login" onClick={(event)=>{event.preventDefault(); navigate("/login");}}>{t("Login")}</a></p>
        </form>
        </div>
    );
};

export default SignupPage;
